<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    reverse?: boolean
  }>(),
  {
    reverse: false,
  },
)
</script>

<template>
  <div class="page">
    <div
      class="page-header mb-6 flex w-full flex-col items-center justify-between gap-4 sm:flex-row"
      :class="props.reverse && 'sm:flex-row-reverse'"
      v-if="'left' in $slots || 'right' in $slots"
    >
      <div class="relative flex w-full items-center gap-4 sm:w-auto">
        <slot name="left"></slot>
      </div>
      <div
        class="relative flex w-full items-center justify-end gap-4 sm:w-auto"
      >
        <slot name="right"></slot>
      </div>
    </div>
    <slot></slot>
  </div>
</template>
